<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">

      <slide>
        <div class="padding">
          <p>I looked down at my hands and thought about all the people they've ever touched, and I wondered if they've every really touched you</p>
          <p style = "font-size:1em">I  looked so hard at the lines on my palm the concentration almost made me dizzy</p>
          <p style = "font-size:0.9em"> I put my hand against the wall next to me and leant firmly against it</p>
          <p style = "font-size:0.7em"> I let the texture of the wall press into my skin. </p>
          <p style = "font-size:0.6em">I think I just wanted to be able to feel the city, to actually feel a palpable sense of home</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
        </div>
      </slide>

    </carousel>

  </div>
</template>

<script>
export default {

  name: '3',

  data () {
    return {
      title: 'A Touch of Home'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
